var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('span',{class:_vm.headlineClass},[_vm._v(_vm._s(_vm.content.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }